import React from 'react';
import PropTypes from 'prop-types';
import { Steps } from 'antd';
import {
  isStageEmpty,
  STAGE_STATUS_ACTIVE,
  STAGE_STATUS_EMPTY,
} from 'utils/profile-stages';

const getStepStatus = ({ isEmpty, isAfter, isCurrent, stageStatus }) => {
  if (isCurrent) {
    return STAGE_STATUS_ACTIVE;
  }
  if (isEmpty && isAfter) {
    return STAGE_STATUS_EMPTY;
  }
  return stageStatus;
};

const SidebarSteps = ({ currentStep, handleStepChange, stages, values }) => {
  return (
    <Steps
      direction="vertical"
      size="small"
      current={currentStep}
      onChange={handleStepChange}
      className="complete-profile-steps"
    >
      {stages.map(
        (
          { title, component, status: stageStatus, fields, getValues, ...rest },
          i
        ) => {
          const isEmpty = isStageEmpty(values, fields);
          const isAfter = i > currentStep;
          const isCurrent = i === currentStep;

          const status = getStepStatus({
            isEmpty,
            isAfter,
            isCurrent,
            stageStatus,
          });

          return <Steps.Step {...rest} key={i} title={title} status={status} />;
        }
      )}
    </Steps>
  );
};

SidebarSteps.propTypes = {
  currentStep: PropTypes.number.isRequired,
  handleStepChange: PropTypes.func.isRequired,
  stages: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
    })
  ).isRequired,
  values: PropTypes.shape(),
};

SidebarSteps.defaultProps = {
  values: {},
};

export default SidebarSteps;
